export default "__VITE_ASSET__gB_DAUJe__"